<template>
<div>
<div id="leftNav">

</div>
<div id="header"></div>
</div>
</template>

<script>
    export default {
        name: "infor-collection",
        data(){
          return{

          }
        },
        methods:{

        },
        mounted(){

        }
    }
</script>

<style lang="less" type="text/less" rel="stylesheet/less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/collection/inforCollection.vue